import React from 'react'
const Image = ({image, alt, title, ...other}) => (image ? <img className="page-image" title={title||image} alt={alt || image}  src={image} {...other} /> : "No image")

export default Image